export default {
  computed: {
    extensionUrl() {
      return this.$i18n.locale !== 'zh' &&
        this.$i18n.locale !== 'zh-tw' &&
        this.$i18n.locale !== 'en'
        ? `https://extension.tokenpocket.pro/?locale=en#/`
        : `https://extension.tokenpocket.pro/?locale=${this.$i18n.locale}#/`;
    },
    supportUrl() {
      switch (this.$i18n.locale) {
        case 'zh':
          return `https://keypal.gitbook.io/zh-cn/`
        case 'zh-tw':
          return `https://keypal.gitbook.io/zh-hk/`
        case 'en':
          return `https://keypal.gitbook.io/en/`
        case 'ja':
          return `https://keypal.gitbook.io/jp/`
        case 'ko':
          return `https://keypal.gitbook.io/kr/`
        case 'fr':
          return `https://keypal.gitbook.io/fr/`
        case 'es':
          return `https://keypal.gitbook.io/es/`
        default:
          break;
      }
    },
  },
};
